import styled from "styled-components";

export const Group = styled.div`
  display: flex;
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  flex-direction: ${({ direction }) => direction || "column"};
  gap: ${({ gap }) => gap || "10px"};
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  flex: ${({ flex }) => flex};
  margin: ${({ margin }) => margin};
  align-self: ${({ stretch }) => stretch};
  flex-wrap: ${({ wrap }) => wrap};
  flex-shrink: ${({ shrink }) => shrink};
  ${({ styling }) => styling};
`;
